import { FlipCameraIosRounded } from '@mui/icons-material';
import {
    Backdrop,
    Button,
    Card,
    CardContent,
    Fade,
    Grid,
    Modal,
    Typography,
} from '@mui/material';
import React, { useState } from 'react';
import QRScanner from 'react-qr-reader2';
import { useDispatch, useSelector } from 'react-redux';
import * as Yup from 'yup';
import Screen from '../../components/fragments/Screen';
import { useTheme } from '@mui/styles';
import { useParams } from 'react-router-dom';
import { useRecordAttendanceMutation } from '../../api/apiSlice';
import FormikButton from '../../components/formik/FormikButton';
import FormikInput from '../../components/formik/FormikInput';
import Form from '../../components/utilities/Form';

const validate = Yup.object().shape({
    temperature: Yup.number()
        .min(2)
        .positive()
        .moreThan(32)
        .lessThan(38)
        .label('Temperature'),
});

export default function ScanQRCameraScreen() {
    const [delay] = useState(100);
    const [open, setOpen] = useState(false);
    const [front, setFront] = useState(true);
    const [result, setResult] = useState('No Result');

    const theme = useTheme();
    const dispatch = useDispatch();
    const params = useParams();
    const state = useSelector((st) => st);

    const { services } = state.list2;

    const [recordAttendance, { isLoading, isSuccess }] =
        useRecordAttendanceMutation();

    const thisChurch = services?.find(
        (church) => church.id.toString() === params.id.toString()
    );

    const handleScan = (data) => {
        if (data) {
            setResult({ service: params.id, member: data });
            setOpen(true);
        }
    };

    const handleError = (err) => {
        // eslint-disable-next-line no-console
        console.error(err);
    };

    const handleClose = () => {
        setOpen(false);
    };

    return (
        <Screen title="Scanning">
            <Grid item xs={12}>
                <div
                    className="d-flex flex-column justify-content-center align-items-center"
                    style={{ flex: 1 }}
                >
                    <Typography
                        sx={{ mb: 1, mx: 2 }}
                        color="primary"
                        variant="h5"
                    >
                        Place the camera to face the QR Code
                    </Typography>
                    <Typography
                        sx={{ mb: 1, mx: 2 }}
                        color="primary"
                        variant="h5"
                    >
                        <b>SERVICE:</b> {thisChurch?.name}
                    </Typography>
                    <div>
                        <QRScanner
                            delay={delay}
                            style={{
                                height: 240,
                                width: 320,
                                marginTop: 20,
                                borderRadius: theme.shape.borderRadius,
                            }}
                            onError={handleError}
                            onScan={handleScan}
                            facingMode={front ? 'environment' : 'user'}
                        />
                    </div>
                    <div style={{ position: 'fixed', bottom: 36 }}>
                        <Button
                            variant={front ? 'outlined' : 'contained'}
                            onClick={() => setFront(!front)}
                            startIcon={<FlipCameraIosRounded />}
                        >
                            Flip Camera
                        </Button>
                    </div>

                    <Modal
                        aria-labelledby="transition-modal-title"
                        aria-describedby="transition-modal-description"
                        className="d-flex justify-content-center align-items-center"
                        open={open}
                        onClose={handleClose}
                        closeAfterTransition
                        BackdropComponent={Backdrop}
                        BackdropProps={{ timeout: 500 }}
                    >
                        <Fade in={open}>
                            <Card
                                style={{
                                    width: '80%',
                                    ':focus': {
                                        outline: 'none',
                                        border: '5px  solid #fff',
                                    },
                                }}
                            >
                                <CardContent>
                                    <Typography variant="h5">
                                        Scan Complete
                                    </Typography>
                                    <Typography variant="h6">
                                        Service: {thisChurch?.name}
                                    </Typography>
                                    <Typography sx={{ mb: 3 }} variant="h6">
                                        Member ID: {result.member}
                                    </Typography>
                                    <Form
                                        validationSchema={validate}
                                        onSubmit={({ temperature }) =>
                                            dispatch(
                                                recordAttendance(
                                                    result,
                                                    temperature
                                                )
                                            )
                                        }
                                        initialValues={{ temperature: '' }}
                                    >
                                        <FormikInput
                                            adornment="&deg;Celcius"
                                            adornmentType="end"
                                            name="temperature"
                                            placeholder="Temperature"
                                            label="Temperature"
                                        />

                                        <div style={{ display: 'flex' }}>
                                            <FormikButton
                                                style={{ marginRight: 10 }}
                                                disabled={isSuccess}
                                                loading={isLoading}
                                                variant="contained"
                                            >
                                                {isSuccess ? 'Saved' : 'Save'}
                                            </FormikButton>
                                            {isSuccess && (
                                                <Button
                                                    variant="outlined"
                                                    onClick={() => {
                                                        dispatch({
                                                            type: 'CLEAR_ATTENDANCE_INFO',
                                                        });
                                                        setOpen(false);
                                                    }}
                                                >
                                                    Scan Next
                                                </Button>
                                            )}
                                        </div>
                                    </Form>
                                </CardContent>
                            </Card>
                        </Fade>
                    </Modal>
                </div>
            </Grid>
        </Screen>
    );
}
